import { createNamespacedHelpers } from 'vuex';

const typingActivity = createNamespacedHelpers('activity/typing');
const keyboard = createNamespacedHelpers('keyboard');

export default {
  props: {
    name: {
      type: String,
      require: true
    },
    character: {
      type: String,
      default: ''
    },
    row: {
      type: String,
      required: true
    },
    alt: String,
    shift: {
      type: Boolean,
      default: false
    },
    special: String
  },

  computed: {
    ...typingActivity.mapState(['attemptedKey']),
    ...keyboard.mapState(['capsLock', 'holdKeyPressed']),
    ...keyboard.mapState({
      isGhosting: state => state.settings.isGhosting,
      keyboardShowing: state => state.show,
      showTargets: state => state.settings.showTargets,
      roofs: state => state.settings.roofs
    }),
    ...keyboard.mapGetters(['activeLetters']),
    ...typingActivity.mapGetters(['targetKey', 'expectedKey', 'isTouchHold']),

    isPressedKey() {
      const attemptedCharacter = this.attemptedKey.character;
      // An empty string indicates no current attempted key
      return attemptedCharacter && this.normalizedCharacter === attemptedCharacter;
    },

    normalizedCharacter() {
      if (this.attemptedKey.withShift || this.capsLock) {
        return this.alt || this.character;
      }

      return this.showSpecial ? this.special : this.character;
    },

    baseClasses() {
      const multiCharacterKeys = ['backspace', 'capslock', 'enter', 'shift1', 'shift2', 'tab'];
      let activeKeys = this.activeLetters;

      // Remove all possible multi character keys if the current key is not one of them.
      if (!multiCharacterKeys.includes(this.character.toLowerCase())) {
        activeKeys = activeKeys.replaceAll(new RegExp(multiCharacterKeys.join('|'), 'gi'), '');
      }

      return {
        ghosting: this.isGhosting,
        active:
          activeKeys.toLowerCase().includes(this.character.toLowerCase()) ||
          this.character === this.targetKey
      };
    },

    keyStateClass() {
      if (this.isPressedKey) {
        return this.attemptedKey.isCorrect ? 'highlight' : 'error';
      }

      return '';
    }
  }
};
